import { render, staticRenderFns } from "./RsxMetaDataFields.vue?vue&type=template&id=393aaf21&scoped=true"
import script from "./RsxMetaDataFields.vue?vue&type=script&lang=js"
export * from "./RsxMetaDataFields.vue?vue&type=script&lang=js"
import style0 from "./RsxMetaDataFields.vue?vue&type=style&index=0&id=393aaf21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393aaf21",
  null
  
)

export default component.exports